export default __webpack_public_path__ + "static/media/citi.845e4734.svg";